import { JobLogLine } from "./jobLogLine.model";


export class JobLog {
  Log: JobLogLine[];
  StartedAt: Date;
  Active: boolean;
}
